import { useQuery, UseQueryOptions } from "react-query";
import { showNotification } from "@mantine/notifications";
import { AxiosError } from "axios";

import { fetchBrainstormIdeas } from "modules/collaboration/api/brainstorming";

import { FetchBrainstormIdeasDto } from "modules/collaboration/types/dto";
import { BrainstormIdeasResponse } from "modules/collaboration/types/res";

export const BRAINSTORM_IDEAS_QUERY_KEY = "/brainstorm_ideas";

type BrainstormIdeasQueryKey = [string, { params: FetchBrainstormIdeasDto }];

export const getBrainstormIdeasQueryKey = (
  params: FetchBrainstormIdeasDto
): BrainstormIdeasQueryKey => [BRAINSTORM_IDEAS_QUERY_KEY, { params }];

export const useBrainstormIdeasQuery = (
  params: FetchBrainstormIdeasDto,
  options: UseQueryOptions<
    BrainstormIdeasResponse,
    AxiosError,
    BrainstormIdeasResponse,
    BrainstormIdeasQueryKey
  > = {}
) => {
  return useQuery<
    BrainstormIdeasResponse,
    AxiosError,
    BrainstormIdeasResponse,
    BrainstormIdeasQueryKey
  >({
    queryKey: getBrainstormIdeasQueryKey(params),
    queryFn: ({ queryKey: [, { params }] }) => fetchBrainstormIdeas(params),
    keepPreviousData: false,
    onError: () => {
      showNotification({
        message: "Couldn't fetch brainstorm ideas, reload the page",
        color: "red"
      });
    },
    ...options
  });
};
